import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useLayoutEffect } from 'react';
import { Layout } from './common/components/layout';
import { ProtectedRoute } from './common/components/ProtectedRoute';
import { LoadingScreen } from './common/components/LoadingScreen';
import { LoginPage, AzureCallback, useAuth } from './features/auth';
import { HomePage } from './pages/HomePage';
import { FilesPage } from './pages/FilesPage';
import { UsersPage } from './pages/UsersPage';
import { AuditPage } from './pages/AuditPage';
import { SharePage } from './pages/SharePage';
import { NotFoundPage } from './pages/NotFoundPage';
import { VideoPage } from './pages/VideoPage';
import { useUIStore } from './store/uiStore';

const PUBLIC_ROUTE_PREFIXES = ['/login', '/auth/azure/callback', '/share/'];

function isPublicRoute(pathname: string): boolean {
  return PUBLIC_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

function App() {
  const { isLoading } = useAuth();
  const location = useLocation();

  useLayoutEffect(() => {
    useUIStore.getState().initTheme();
  }, []);

  if (isLoading && !isPublicRoute(location.pathname)) {
    return <LoadingScreen />;
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/azure/callback" element={<AzureCallback />} />
      <Route path="/share/:token" element={<SharePage />} />

      {/* Protected routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/files" element={<FilesPage />} />
          <Route path="/files/view/:fileId" element={<VideoPage />} />
          <Route path="/files/:folderId" element={<FilesPage />} />

          {/* Admin only */}
          <Route element={<ProtectedRoute allowedRoles={['admin']} />}>
            <Route path="/users" element={<UsersPage />} />
          </Route>

          {/* Admin and Manager */}
          <Route element={<ProtectedRoute allowedRoles={['admin', 'manager']} />}>
            <Route path="/audit" element={<AuditPage />} />
          </Route>
        </Route>
      </Route>

      {/* Fallback */}
      <Route path="/404" element={<NotFoundPage />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
}

export default App;
